import { IGameProvider } from "@base/features/game/model/interfaces";
import { container } from "tsyringe";

export default function BackgammonOption(props: {children: JSX.Element}) {
  const gameProvider: IGameProvider = container.resolve('gameProvider');
  return (gameProvider.GAME_ID === 5) ? props.children : null;
}
